// extracted by mini-css-extract-plugin
export default {"button":"styles_button__h77ZL","secondary":"styles_secondary__tFr0L","bgSecondary":"styles_bgSecondary__DW0bg"};